import React, { useCallback, useContext } from 'react';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';

import { EadNode } from 'types';
import { GridActionButtonComponent } from 'components/grid/grid-types';
import {
  addEadToFavourites,
  removeEadFromFavourites,
} from 'modules/portfolio-favourite/favourite-api';
import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';
import { AuthCtx } from 'components/auth/auth-ctx';
import { getNodeId } from 'components/grid/grid-ctx/ctx-utils';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export const EadFavourite = ({
  item,
  refreshRootArchivalAid,
}: GridActionButtonComponent) => {
  const classes = useStyles();
  const { userInfo } = useContext(AuthCtx);

  const { showNotification } = useContext(NotificationCtx);

  const eadNode = item as EadNode;
  const isFavourite = !!eadNode?.favourite;

  const handleAddToFavourites = useCallback(async () => {
    const response = await addEadToFavourites(getNodeId(eadNode)!);

    if (response.ok) {
      showNotification(
        'EAD uzel byl úspěšně přidán mezi oblíbené.',
        NotificationVariant.SUCCESS
      );
      refreshRootArchivalAid();
    } else {
      showNotification(
        'Při přidávání EAD uzlu mezi oblíbené nastala chyba.',
        NotificationVariant.ERROR
      );
    }
  }, [eadNode, showNotification, refreshRootArchivalAid]);

  const handleRemoveFromFavourites = useCallback(async () => {
    const response = await removeEadFromFavourites(getNodeId(eadNode)!);

    if (response.ok) {
      showNotification(
        'EAD uzel byl úspěšně odebrán z oblíbených.',
        NotificationVariant.SUCCESS
      );
      refreshRootArchivalAid();
    } else {
      showNotification(
        'Při odebíraní EAD uzlu z oblíbených nastala chyba.',
        NotificationVariant.ERROR
      );
    }
  }, [eadNode, showNotification, refreshRootArchivalAid]);

  if (!userInfo?.aisAuthenticated) {
    return <></>;
  }

  return (
    <Button
      component="span"
      variant="outlined"
      color="primary"
      className={classes.navigationButton}
      onClick={isFavourite ? handleRemoveFromFavourites : handleAddToFavourites}
    >
      {isFavourite ? 'Odstraň z oblíbených' : 'Přidej k oblíbeným'}
    </Button>
  );
};
